var _desc, _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHubspotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "248px",
    height: "246px",
    viewBox: "0 0 248 246",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide---Homepage",
    transform: "translate(-457.000000, -5385.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(457.000000, 5385.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-3-Copy",
    fill: "#FF7A59",
    x: 0,
    y: 0,
    width: 248,
    height: 246
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,156 C145.954135,156 137,147.045435 137,136.00096 C137,124.954565 145.954135,116 157,116 C168.045865,116 177,124.954565 177,136.00096 C177,147.045435 168.045865,156 157,156 M162.886907,97.7105755 L162.886907,80.090081 C167.543947,77.9176913 170.805799,73.2650141 170.805799,67.8653997 L170.805799,67.4586705 C170.805799,60.0064044 164.632335,53.9092686 157.086776,53.9092686 L156.676879,53.9092686 C149.13132,53.9092686 142.957855,60.0064044 142.957855,67.4586705 L142.957855,67.8653997 C142.957855,73.2650141 146.219708,77.9195919 150.876748,80.0919816 L150.876748,97.7105755 C143.943146,98.7692117 137.608033,101.593508 132.383296,105.750128 L83.3977794,68.1162793 C83.721078,66.8903901 83.9481568,65.6283894 83.9500812,64.3017682 C83.9577788,55.8630889 77.0414973,49.0114135 68.4933274,49.0000099 C59.9490063,48.9905069 53.009632,55.8231763 53.00001,64.2637562 C52.990388,72.704336 59.9066696,79.5560115 68.4548394,79.5655145 C71.2394414,79.5693157 73.8181329,78.7881677 76.0773745,77.5185646 L124.262342,114.540419 C120.165302,120.648958 117.763655,127.966282 117.763655,135.844283 C117.763655,144.091001 120.402002,151.720024 124.858905,157.993916 L110.206549,172.467011 C109.048062,172.123002 107.847239,171.883526 106.573288,171.883526 C99.5511648,171.883526 93.8568751,177.50551 93.8568751,184.440812 C93.8568751,191.378015 99.5511648,197 106.573288,197 C113.597336,197 119.289701,191.378015 119.289701,184.440812 C119.289701,183.186414 119.047227,181.998537 118.698911,180.854374 L133.193467,166.539029 C139.772979,171.497703 147.96706,174.477849 156.882789,174.477849 C178.487991,174.477849 196,157.180457 196,135.844283 C196,116.52845 181.632455,100.570984 162.886907,97.7105755",
    id: "Marketing/Logos/Sprocket",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotLogo);
export default __webpack_public_path__ + "static/media/hubspot-logo.b0720a2d86c9e250c1fc21cf35958b71.svg";
export { ForwardRef as ReactComponent };